import { createEffect, Actions, ofType } from '@ngrx/effects';
import { catchError, concatMap, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
  fetchUsersSuccess,
  fetchUsersRequest,
  fetchUsersFailure,
  createUsersRequest,
  createUsersFailure,
  createUsersSuccess,
  deleteUsersRequest,
  deleteUsersSuccess,
  deleteUsersFailure,
} from './user.actions';
import { UserService } from './user.service';
import { of } from 'rxjs';
import { Router } from '@angular/router';

@Injectable()
export class UserEffects {
  constructor(
    private usersService: UserService,
    private actions$: Actions,
    private snackBar: MatSnackBar,
    private router: Router
  ) {}

  public fetchUsersRequest$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(fetchUsersRequest),
      concatMap(() => {
        return this.usersService.getAllUsers().pipe(
          map((response) => fetchUsersSuccess({ users: response })),
          catchError((error) => {
            console.log(error);
            return of(fetchUsersFailure());
          })
        );
      })
    );
  });

  public createUsersRequest$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(createUsersRequest),
      concatMap((action) => {
        return this.usersService.createUser(action.payload).pipe(
          map((response) => {
            this.router.navigate(['/main/users']);
            return createUsersSuccess({ user: response });
          }),
          catchError((error) => {
            if (error.status === 400) {
              this.snackBar.open('Validation error', null, {
                duration: 10000,
              });
            } else {
              this.snackBar.open(error.error.message, null, {
                duration: 10000,
              });
            }
            return of(createUsersFailure());
          })
        );
      })
    );
  });

  public deleteUsersRequest$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(deleteUsersRequest),
      concatMap((action) => {
        return this.usersService.deleteUsers(action.payload).pipe(
          map(() => deleteUsersSuccess({ ids: action.payload.ids })),
          catchError((error) => {
            console.log(error);
            return of(deleteUsersFailure());
          })
        );
      })
    );
  });
}
